import * as React from 'react'

const StudioLayoutContentInsetContext = React.createContext(0)

/**
 * Reserves space on the right of `StudioLayout` for a sibling panel, such as a docked chat rail.
 * `StudioLayoutShell` reads this and narrows the layout by that many pixels. `0` means full width.
 */
export function StudioLayoutContentInsetProvider({
  rightInsetPx,
  children,
}: {
  rightInsetPx: number
  children: React.ReactNode
}) {
  return (
    <StudioLayoutContentInsetContext.Provider value={rightInsetPx}>
      {children}
    </StudioLayoutContentInsetContext.Provider>
  )
}

/** Right inset in pixels. `0` when no provider is mounted or nothing is docked. */
export function useStudioLayoutContentInset() {
  return React.useContext(StudioLayoutContentInsetContext)
}
